<template>
  <v-container class="login" fill-height fluid justify-center>
    <div class="inner">
      <v-text-field
        label="ログインID"
        placeholder=" "
        v-model.trim="username"
      ></v-text-field>
      <v-text-field
        label="パスワード"
        placeholder=" "
        type="password"
        v-model.trim="password"
      ></v-text-field>
      <div style="width: 100%; text-align: center">
        <!-- <v-btn to="/b0101">新規申込</v-btn> -->
        <v-btn @click="login" color="#fec42d">ログイン</v-btn>
        <v-btn @click="forgetPwd" color="#fec42d">パスワード忘れ？</v-btn>
      </div>
    </div>
    <email-blank ref="blank"></email-blank>
  </v-container>
</template>

<script>
import UpdatePassword from "@/components/UpdatePassword";
import EmailBlank from "@/components/EmailBlank";

export default {
  components: {
    EmailBlank,
    UpdatePassword,
  },
  data() {
    return {
      show: false,
      username: "",
      password: "",
      valid: false,
      newPassword: null,
      againPassword: null,
    };
  },
  methods: {
    changeUI() {
      console.log("change ui");
      this.$setEmployee().then(() => {
        var employee = JSON.parse(localStorage.getItem("currentEmployee"));
        console.log(employee);
        if (employee.companyName === "SHARP") {
          this.$changeUI("sharp-ui");
        } else {
          this.$changeUI("jusda-ui");
        }
      });
    },
    getConfig() {
      this.$http.get(`/configs/files/config`).then((res) => {
        localStorage.setItem("accessKeyId", res.data.accessKeyId);
        localStorage.setItem("accessKeySecret", res.data.accessKeySecret);
        localStorage.setItem("bucketName", res.data.bucketName);
        localStorage.setItem("region", res.data.region);
      });
    },
    login() {
      var sendDate = new Date().getTime();
      this.$login(this.username, this.password)
        .then((user) => {
          console.log("newUser" + user);
          this.$http
            .get(`/employees/current`)
            .then((res) => {
              this.getConfig();
              var adjustUser = {
                ...res.data,
                ...user,
              };
              localStorage.setItem("user", JSON.stringify(adjustUser));
              this.changeUI();
              this.$store.dispatch("LOGIN", adjustUser);
              this.lastLoginTime(adjustUser.userAccountId);
              this.checkChangePwd(adjustUser.userAccountId).then((res) => {
                var path;
                if (this.onlyHasTdoc(adjustUser)) {
                  path = "/t-doc";
                } else {
                  path = this.$route.query.redirect || "/";
                }
                if (res.data.result) {
                  this.$router.push({
                    path: path,
                    query: {
                      changePassword: true,
                      type: res.data.type,
                      blNo: this.$route.query.blNo,
                    },
                  });
                } else {
                  this.$router.push({
                    path: path,
                    query: {
                      changePassword: false,
                      blNo: this.$route.query.blNo,
                    },
                  });
                }
              });
              this.$buriedPoint1();
            })
            .catch(() => {
              this.logOff();
              this.$message("", "当該ユーザーはシステムに登録されていません");
            });
        })
        .catch((err) => {
          console.log(err);
          var receiveDate = new Date().getTime();
          var responseTimeMs = receiveDate - sendDate;
          if (responseTimeMs > 500000) {
            this.$message(
              "ERROR",
              "タイムアウトですので、ログインできません。"
            );
          } else if (err && 401 === err.status) {
            this.$message("ERROR", "Auth Expired");
          } else {
            this.logOff();
            this.$showApiError(err);
          }
        });
    },
    logOff() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem("currentEmployee");
      this.$store.dispatch("LOGOUT");
    },
    lastLoginTime(id) {
      this.$http.put("/employees/log-logintime?userAccountId=" + id);
    },
    checkChangePwd(id) {
      return this.$http.get("/employees/need-change-pwd?userAccountId=" + id);
    },
    forgetPwd() {
      this.$refs.blank.popup();
    },
    onlyHasTdoc(user) {
      var userRoles = user.roles;
      var tdocRoles = [
        "ROLE_SHRP_TDOC_VIEWER",
        "ROLE_TDOC_CARRIER",
        "ROLE_SJL_SHIPPER",
        "ROLE_WEB_VIEWER",
      ];
      var onlyHas = true;
      userRoles.forEach((r) => {
        if (tdocRoles.indexOf(r.roleCode) === -1) {
          onlyHas = false;
        }
      });
      return onlyHas;
    },
  },
  mounted() {
    var redirectUrl = this.$route.query.redirect;
    var blNo = this.$route.query.blNo;
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({
        path: redirectUrl,
        query: {
          blNo: blNo,
        },
      });
    }
  },
};
</script>

<style scoped>
.login {
  background: transparent url(../../assets/img/login.png) no-repeat 50% 50%;
}

.inner {
  position: relative;
  left: 130px;
  width: 400px;
}
</style>
